import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import { WarehousePropTypes } from '@/common/proptypes/Common/Warehouse/Warehouse.proptypes';

export const LoginContainerDefaultProps = {
  errors: [],
  onSubmit: () => {},
  paramIsOpen: false,
};

export const LoginContainerPropTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    ),
  ]),
  onSubmit: PropTypes.func,
  paramIsOpen: PropTypes.bool,
};

export const LoginDefaultProps = {
  ...DisabledDefaultProps,
  company: null,
  errors: [],
  onSubmit: () => {},
  paramIsOpen: false,
  warehouse: {},
};

export const LoginPropTypes = {
  ...DisabledPropTypes,
  company: PropTypes.string,
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    ),
  ]),
  onSubmit: PropTypes.func,
  paramIsOpen: PropTypes.bool,
  warehouse: PropTypes.shape({
    ...WarehousePropTypes,
  }),
};
